import React from "react";

export default function Error() {
  return (
    <div className="h-screen w-screen bg-white flex justify-center items-center">
      <img alt="404" className="w-[25vw]" src="/404.png" />
    </div>
  );
}
